"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterByPeriod = void 0;
const react_1 = require("react");
const selectors_1 = require("../../selectors");
const slice_1 = require("../../slice");
const hooks_1 = require("../../../../store/hooks");
const useFilterByPeriod = ({ items, listKey, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const filters = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getEventListFilters)(state, listKey));
    const value = (0, react_1.useMemo)(() => items.find((item) => item.value === (filters === null || filters === void 0 ? void 0 : filters.period)) || items[0], [items, filters]);
    const onChangeTimePeriod = (0, react_1.useCallback)((option) => {
        if ((value === null || value === void 0 ? void 0 : value.id) !== option.id) {
            dispatch(slice_1.eventsProviderActions.updateFilters({
                listKey,
                filters: {
                    period: option.value,
                },
            }));
        }
    }, [dispatch, listKey, value === null || value === void 0 ? void 0 : value.id]);
    return (0, react_1.useMemo)(() => ({
        onChangeTimePeriod,
        value,
        items,
    }), [onChangeTimePeriod, value, items]);
};
exports.useFilterByPeriod = useFilterByPeriod;
//# sourceMappingURL=useFilterByPeriod.js.map